import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { signInErrorMessage } from '../lib/sign-in-errors';

/** The `?error=` of a sign-in that returned to this page. A new attempt calls `dismiss`, so the old error goes away. */
export function useSignInError(): { code: string | null; message: string | null; dismiss: () => void } {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('error');
  const [dismissed, setDismissed] = useState<string | null>(null);
  return {
    code,
    message: code !== null && code !== dismissed ? signInErrorMessage(code) : null,
    dismiss: () => setDismissed(code),
  };
}
